module.exports = __webpack_public_path__ + "static/bracu-2-c6453500d8d151d94bc93eea78d90c56.jpg";